import React from "react";
import {
  Button,
  createStyles,
  Grid,
  makeStyles,
  Typography,
  useTheme,
} from "@material-ui/core";
import { CustomTheme } from "../../../../types/customTheme";
import ButtonCommon from "../../../buttons/ButtonCommon";

const useStyles = makeStyles((theme: any) =>
  createStyles({
    button: {
      borderRadius: "10px",
      height: "10px,",
      backgroundColor: theme.palette.custom.yellow.main,
      color: theme.palette.custom.yellow.contrastText,
      width: "100%",
      "&:hover": {
        backgroundColor: theme.palette.custom.yellow.dark,
      },
    },
  }),
);

export interface VoidSummeryProps {
  topic: any;
  filterDate: any;
  handleOnClickText: any;
  getDailySaleReportInfo?: any;
  filterData?: any;
  isBasedOnShift?: any;
  isNotNotFound?: any
}

const SalePageTitleAndLocationDetails: React.FunctionComponent<
  VoidSummeryProps
> = ({
  topic,
  filterDate,
  handleOnClickText,
  getDailySaleReportInfo,
  filterData,
  isBasedOnShift,
}) => {
  const classes = useStyles();
  const theme: CustomTheme = useTheme();
  return (
    <Grid
      container
      // direction="row"
      // alignItems="center"
    >
      <Grid
        item
        xs={8}
        style={{
          display: "flex",
          justifyContent: "start",
          marginTop: "36px",
        }}
      >
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", cursor: "pointer" }}
          color="secondary"
          align="left"
          onClick={() => handleOnClickText()}
        >
          {topic}
        </Typography>
      </Grid>
      
      <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "start" }}
        onClick={() => handleOnClickText()}
      >
        <Typography
          variant="body1"
          style={{
            fontWeight: "bold",
            cursor: "pointer",
            color: theme.palette.custom.orange.contrastText,
          }}
        >
          {filterDate}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SalePageTitleAndLocationDetails;
